import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { SectionHeading } from '@/components/base/SectionHeading';
import { articles, articleCategories } from '@/mocks/articles';

export default function ArticleList() {
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const filteredArticles =
    activeCategory === 'all'
      ? articles
      : articles.filter((a) => {
          if (activeCategory === 'brand-story') return a.category === '品牌故事';
          if (activeCategory === 'skincare-guide') return a.category === '护肤指南';
          if (activeCategory === 'ingredient-deep-dive') return a.category === '成分揭秘';
          if (activeCategory === 'skincare-philosophy') return a.category === '护肤哲学';
          return true;
        });

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: '灵感笔记 - 幼水若若',
            description: '幼水若若品牌故事、护肤指南与生活灵感分享。',
            url: 'https://ruoruworld.github.io/articles',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://ruoruworld.github.io/' },
              { '@type': 'ListItem', position: 2, name: '灵感笔记' },
            ],
          }),
        }}
      />

      <div className="pt-24 pb-20 md:pt-28 md:pb-28 px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '灵感笔记' }]} />

          <div className="mt-8">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 tracking-wide">
              灵感笔记
            </h1>
            <p className="mt-2 text-sm text-foreground-500 max-w-xl">
              品牌故事、护肤指南、成分揭秘——与幼水若若一起探索温和护肤的智慧。
            </p>
          </div>

          {/* Category Filter */}
          <div className="mt-8 flex items-center gap-2 overflow-x-auto pb-2">
            {articleCategories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveCategory(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Article Grid */}
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/40 transition-all duration-300"
              >
                <div className="w-full h-56 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs">
                      {article.category}
                    </span>
                    <span>{article.date}</span>
                    <span>·</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h2 className="mt-3 text-lg font-heading text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h2>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                    {article.excerpt}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-500">
                    阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="mt-14 text-center py-16">
              <p className="text-foreground-400">暂无相关文章</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}